export default __webpack_public_path__ + "static/media/photo--lg--61.57f30421.jpg";